import { Component } from '@theme/component';

/**
 * Cart drawer upsell card. Clicking the media or title opens a responsive
 * in-drawer zoom dialog showing the product image (no redirect).
 */
class CartUpsellComponent extends Component {
  requiredRefs = [];

  connectedCallback() {
    super.connectedCallback();
    this.#boundBackdropClick = this.#onBackdropClick.bind(this);
    this.refs.zoomDialog?.addEventListener('click', this.#boundBackdropClick);
    this.addEventListener('click', this.#handleAddClick);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.refs.zoomDialog?.removeEventListener('click', this.#boundBackdropClick);
    this.removeEventListener('click', this.#handleAddClick);
  }

  /**
   * Shows a checkmark on the "+" button while the add-to-cart request runs.
   * The drawer re-renders on success, which naturally resets the button.
   */
  #handleAddClick = (event) => {
    if (!(event.target instanceof Element)) return;
    const button = event.target.closest('.cart-upsell__add');
    if (!button || !this.contains(button)) return;

    button.classList.add('is-added');
    setTimeout(() => button.classList.remove('is-added'), 3000);
  };

  openZoom() {
    this.refs.zoomDialog?.showModal();
  }

  closeZoom() {
    this.refs.zoomDialog?.close();
  }

  #boundBackdropClick;

  #onBackdropClick(event) {
    if (event.target === this.refs.zoomDialog) {
      this.closeZoom();
    }
  }
}

if (!customElements.get('cart-upsell-component')) {
  customElements.define('cart-upsell-component', CartUpsellComponent);
}
